import React from 'react';
import { CheckCircle2, ShieldCheck, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="w-full bg-navy py-24 px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden" data-id="element-41">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl sm:text-5xl font-heading font-black text-white mb-6" data-id="element-43">
          Dale orden a tus clases y progresiones
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-gray-300 text-lg sm:text-xl mb-12" data-id="element-44">
          Comprá ahora y prepará tu sistema de entrenamiento.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="max-w-xl mx-auto" data-id="element-45">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-46">
            <span className="text-gray-400 line-through text-xl font-medium" data-id="element-47">
              232 USD
            </span>
            <span className="text-5xl sm:text-6xl font-heading font-black text-white" data-id="element-48">
              17 USD
            </span>
          </div>

          <div className="inline-block bg-primary/20 text-primary font-bold px-4 py-2 rounded-full text-sm mb-8 border border-primary/30" data-id="element-49">
            Incluye 5 bonos gratis · Ahorrás 215 USD
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left mb-10 text-gray-300 text-sm max-w-md mx-auto" data-id="element-50">
            {['Bono #1 · 50 Calentamientos', 'Bono #2 · Juegos de Cierre', 'Bono #3 · Clases Especiales', 'Bono #4 · Kit de Consignas', 'Bono #5 · Plantillas Semanales'].map((bono, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-51">
                <CheckCircle2 className="w-4 h-4 text-success shrink-0" data-id="element-52" />
                <span data-id="element-53">{bono}</span>
              </div>)}
          </div>

          <button className="w-full sm:w-auto min-w-[300px] bg-primary hover:bg-primary-hover text-white font-heading font-black text-xl py-5 px-8 rounded-xl shadow-[0_8px_24px_0_rgba(241,90,41,0.4)] transition-all transform hover:-translate-y-1 mb-6 flex items-center justify-center gap-2 mx-auto" data-id="element-54">
            Finalizar compra y descargar — 17 USD
          </button>

          <div className="flex items-center justify-center gap-4 text-xs font-medium text-gray-400" data-id="element-55">
            <span className="flex items-center gap-1" data-id="element-56">
              <ShieldCheck className="w-4 h-4" data-id="element-57" /> Pago seguro
            </span>
            <span data-id="element-58">•</span>
            <span className="flex items-center gap-1" data-id="element-59">
              <Zap className="w-4 h-4" data-id="element-60" /> Acceso inmediato
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}